import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { AiResponseReviewService } from "@app/operations/ai-response-review/aiResponseReviewService";
import { AiResponseReviewHealthMetrics } from "@app/operations/ai-response-review/interfaces";

interface UseAiResponseHealthMetricsResult {
  healthMetrics: AiResponseReviewHealthMetrics | null;
  isLoading: boolean;
}

/**
 * Supplementary banner metrics. Failures are swallowed on purpose — the banner is
 * decoration and must never take the review table down with it.
 */
export const useAiResponseHealthMetrics = (): UseAiResponseHealthMetricsResult => {
  const service = useMemo(() => new AiResponseReviewService(), []);

  const { data, isFetching } = useQuery({
    queryFn: ({ signal }) => service.getHealthMetrics(signal),
    queryKey: ["ai-response-review-health-metrics"],
    staleTime: 5 * 60 * 1000,
  });

  return {
    healthMetrics: data ?? null,
    isLoading: isFetching,
  };
};
